import { GeneralErrorsModalType } from "../ServiceModal.types";
import { ServiceModalInnerContainerStyles } from "../ServiceModal.styles";
import { ModalConstructor } from "../../ModalConstructor";
import { useEffect } from "react";
import { SELF_CLOSING_MODAL_TIMEOUT_TIME_TO_CLOSE } from "../../ServiceFunctionsModal.types";
import { GeneralErrorsModalState } from "./GeneralErrorsModalState";
import { ErrorState } from "./GlobalState";

export function GeneralErrorsModal(
    generalErrorsModalProps: GeneralErrorsModalType
) {
    const modalProps = GeneralErrorsModalState({
        ...generalErrorsModalProps,
    });

    useEffect(() => {
        if (modalProps?.autoClosingModal) {
            const timeoutId = setTimeout(() => {
                generalErrorsModalProps.onClose();
            }, SELF_CLOSING_MODAL_TIMEOUT_TIME_TO_CLOSE);

            return () => {
                clearTimeout(timeoutId);
            };
        }
    }, [generalErrorsModalProps.modalCurrentAction]);

    const onTransitionExited = () => {
        generalErrorsModalProps.setCurrentErrorState(ErrorState.STATE_INITIAL);
    };

    return (
        <ModalConstructor
            onClose={generalErrorsModalProps.onClose}
            onCloseTransitionExited={onTransitionExited}
            open={generalErrorsModalProps.open}
            modalContent={modalProps?.modalContent && modalProps.modalContent}
            modalActions={modalProps?.modalActions && modalProps.modalActions}
            modalTitle={modalProps?.modalTitle && modalProps.modalTitle}
            isBorderRadiusVisible={true}
            isInsideClosingButtonVisible={false}
            isOutsideClosingButtonVisible={true}
            modalInnerContainerStyles={ServiceModalInnerContainerStyles}
        />
    );
}
